import { useMutation } from '@tanstack/react-query';
import type { AgentApiCandidateImportRequestsRecord } from '@/types/serializers';

interface CreateCandidateImportRequestParams {
  file: File;
  csvMappingTemplateId?: number;
}

export const useCreateCandidateImportRequest = () => {
  return useMutation({
    mutationFn: async (params: CreateCandidateImportRequestParams) => {
      const formData = new FormData();
      formData.append('file', params.file);
      if (params.csvMappingTemplateId) {
        formData.append('csv_mapping_template_id', params.csvMappingTemplateId.toString());
      }

      const response = await fetch('/agent/api/candidate_import_requests', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token':
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '',
        },
      });

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ message: 'アップロードに失敗しました' }));
        throw new Error(errorData.message || 'アップロードに失敗しました');
      }

      const data: AgentApiCandidateImportRequestsRecord = await response.json();
      return data;
    },
  });
};
